import ProductCardFlag from './themes/BGH/ProductCardFlag';

export default ProductCardFlag;
